import { Component } from '@angular/core';

@Component({
  selector: 'app-sale-marketing',
  standalone: true,
  imports: [],
  templateUrl: './sale-marketing.component.html',
  styleUrl: './sale-marketing.component.scss'
})
export class SaleMarketingComponent {

}
